import React from "react";
import classnames from "classnames";

import Placeholder, { Rect } from "@/components/Skeleton";

const DispensaryCardPlaceholder: React.FC<{
  /**
   * Whether to show an accessory tray, replaces the CTA button
   */
  accessoryTray?: boolean;
  /**
   * Optional className to apply to the card container
   */
  className?: string;
  /**
   * Minimizes certain parts of the card height, e.g. for Finder map view carousel
   */
  compact?: boolean;
  /**
   * A unique identifier - required if using in a SSR rendered component.
   */
  id: string;
  /**
   * Boolean value to set a min-height style on some contents of
   * the card to keep them inline even if missing
   */
  offerTray?: boolean;
  preserveHeight?: boolean;
  /**
   * Which variant of the card to display, defaults to standard
   */
  variant?: "platinum" | "standard" | "info";
}> = (props) => {
  const {
    accessoryTray,
    className,
    compact,
    offerTray,
    preserveHeight,
    variant = "standard",
    ...others
  } = props;
  const imageHeight = String(variant === "platinum" ? 128 : compact ? 32 : 48);
  return (
    <div
      className={classnames(
        "flex flex-col items-start justify-between w-full h-full rounded overflow-hidden bg-white shadow-low p-lg",
        className,
      )}
      {...others}
    >
      {variant !== "info" ? (
        <>
          <div>
            <Placeholder
              width={variant === "platinum" ? "100%" : compact ? "32" : "48"}
              height={imageHeight}
              className="mb-md"
            >
              <Rect width="100%" height="100%" />
            </Placeholder>

            <div style={{ minHeight: preserveHeight ? 44 : 0 }}>
              <Placeholder width="90%" height="16">
                <Rect width="100%" height="100%" />
              </Placeholder>
              <Placeholder width="70%" height="16" className="mt-2">
                <Rect width="100%" height="100%" />
              </Placeholder>
            </div>

            <Placeholder width="120" height="10" className="mt-2">
              <Rect width="100%" height="100%" />
            </Placeholder>

            <div className="flex mt-sm">
              <Placeholder width="66" height="20" className="mt-xs mr-xs">
                <Rect width="100%" height="100%" />
              </Placeholder>
              <Placeholder width="66" height="20" className="mt-xs">
                <Rect width="100%" height="100%" />
              </Placeholder>
            </div>

            <div className="mt-md ">
              <Placeholder width="70%" height="13">
                <Rect width="100%" height="100%" />
              </Placeholder>
              <Placeholder width="40%" height="13" className="mt-sm">
                <Rect width="100%" height="100%" />
              </Placeholder>
            </div>
          </div>

          {accessoryTray && (
            <div className="border-light-grey border-t mt-lg pt-md w-full">
              <Placeholder width="80" height="14">
                <Rect width="100%" height="100%" />
              </Placeholder>
              <div className="flex justify-between mt-sm">
                <Placeholder width="28%" height="14">
                  <Rect width="100%" height="100%" />
                </Placeholder>
                <Placeholder width="39%" height="14">
                  <Rect width="100%" height="100%" />
                </Placeholder>
                <Placeholder width="28%" height="14">
                  <Rect width="100%" height="100%" />
                </Placeholder>
              </div>
            </div>
          )}

          {offerTray && preserveHeight && (
            <div className="min-h-10 mt-lg"></div>
          )}
        </>
      ) : (
        <div className="w-full">
          <Placeholder width="100%" height="18" className="mt-xs">
            <Rect width="100%" height="100%" />
          </Placeholder>
          <div className="mt-md">
            <Placeholder width="70%" height="13">
              <Rect width="100%" height="100%" />
            </Placeholder>
            <Placeholder width="40%" height="13" className="mt-xs">
              <Rect width="100%" height="100%" />
            </Placeholder>
          </div>
        </div>
      )}
    </div>
  );
};

export default DispensaryCardPlaceholder;
